export default __webpack_public_path__ + "static/media/challenge7.264f09e8.jpg";